import React from 'react';
import PropTypes from 'prop-types';
// MATERIAL-UI
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import Typography from '@mui/material/Typography';
// MATERIAL ICONS
import Settings from '@mui/icons-material/Settings';
// COMPONENTS
import SubscriptionInfoDlg from './SubscriptionInfoDlg';
// FETCH & CONFIG
import SiteFetch from '../../../fetch/SiteFetch';
import AppConfig from '../../../appConfig';
// STYLE & ICONS
import { white } from '../../../styles/miEdgeColors';

class AccountMenu extends React.Component {
  getInitialState = () => {
    return {
      anchorEl: null,
      menuOpen: false,
    };
  };
  constructor(props) {
    super(props);

    const ACCOUNT_TYPE_TEST = 2;
    const ACCOUNT_TYPE_ONLINE = 3;
    const ACCOUNT_TYPE_ENTERPRISE = 4;
    const USER_ROLE_ADMIN_USER = '1';
    const USER_ROLE_GROUP_ADMIN = '2';

    let account_type = 0;
    let user_role = '';
    let flag_show_upgrade_subscription = false;
    let allowManageUsers = false;
    let allowGroupActivityReport = false;
    let allowAllActivityReport = false;
    let alllowUsageReport = false;
    let accountId = 0;

    const { userInfo } = this.props;

    // Extract user info from PROPS
    if (userInfo) {
      account_type = userInfo.type;
      user_role = userInfo.role;
      flag_show_upgrade_subscription = userInfo.flag_show_upgrade_subscription;
      accountId = userInfo.account_id;

      /* https://github.com/miEdge/app.newEdge/issues/804
                Admin menu options
                    1) - Apply to enterprise account administrators only
                        Activity Reports
                        Generic activity reports
                        Group reports
                        Manage Users

                    2) Apply to single online users only
                        Billing Portal
                        Upgrade Subscription
                        Subscription Info

                    3) Apply to test users only
                        Generic Activity Reports
                        Group Reports
            */

      if (
        account_type === ACCOUNT_TYPE_ENTERPRISE &&
        (user_role === USER_ROLE_ADMIN_USER || user_role === USER_ROLE_GROUP_ADMIN)
      ) {
        // Enterprise user, is User admin or Group admin
        allowManageUsers = userInfo.miedge_acl && userInfo.miedge_acl.ENTERPERISE_ACC_ADMIN === '1';

        allowGroupActivityReport =
          userInfo.miedge_acl &&
          userInfo.miedge_acl.ACTIVITY_REP_GROUP === '1' &&
          userInfo.miedge_acl.ACTIVITY_REP_ALL !== '1';

        allowAllActivityReport =
          userInfo.miedge_acl && userInfo.miedge_acl.ACTIVITY_REP_ALL === '1';

        alllowUsageReport = true;
      }
    }

    let menu_billing_portal_display = false;
    let menu_upgrade_subscription_display = false;
    let menu_subscription_info_display = false;

    if (account_type === ACCOUNT_TYPE_ONLINE || account_type === ACCOUNT_TYPE_ENTERPRISE) {
      // Online || enterprise users
      menu_billing_portal_display = user_role === USER_ROLE_GROUP_ADMIN; // Group-admin
    }

    if (account_type === ACCOUNT_TYPE_ONLINE) {
      // Online user
      menu_billing_portal_display = user_role === USER_ROLE_GROUP_ADMIN; // Group-admin
      menu_upgrade_subscription_display = flag_show_upgrade_subscription === true;
      menu_subscription_info_display = true;
    }

    if (account_type === ACCOUNT_TYPE_TEST) {
      // Test user
      allowAllActivityReport = userInfo.miedge_acl && userInfo.miedge_acl.ACTIVITY_REP_ALL === '1';
    }

    const enableShowAccountMenu =
      allowManageUsers ||
      allowGroupActivityReport ||
      allowAllActivityReport ||
      menu_billing_portal_display ||
      menu_upgrade_subscription_display ||
      menu_subscription_info_display ||
      alllowUsageReport;

    this.state = Object.assign({}, this.getInitialState(props), {
      enableShowAccountMenu: enableShowAccountMenu,
      menu_billing_portal_display: menu_billing_portal_display,
      menu_upgrade_subscription_display: menu_upgrade_subscription_display,
      menu_subscription_info_display: menu_subscription_info_display,
      subscriptionInfoDlgOpen: false,
      renewal_date: '',
      exportHistoryDlgOpen: false,
      exportHistoryList: [],
      exportHistoryIntervalID: 0,
      accountMenuSnackbarOpen: false,
      accountMenuSnackbarMessage: '',
      isAccountMenuError: false,
      allowManageUsers: allowManageUsers,
      allowGroupActivityReport: allowGroupActivityReport,
      allowAllActivityReport: allowAllActivityReport,
      alllowUsageReport: alllowUsageReport,
      accountId: accountId,
    });
  }

  render() {
    const {
      accountId,
      accountMenuSnackbarMessage,
      accountMenuSnackbarOpen,
      allowGroupActivityReport,
      allowAllActivityReport,
      alllowUsageReport,
      allowManageUsers,
      anchorEl,
      enableShowAccountMenu,
      isAccountMenuError,
      menu_billing_portal_display,
      menu_subscription_info_display,
      menu_upgrade_subscription_display,
      menuOpen,
      renewal_date,
      subscriptionInfoDlgOpen,
    } = this.state;

    if (!enableShowAccountMenu) {
      return <span />;
    }

    return (
      <span>
        <Button
          onClick={this.handleClickAccountMenu}
          sx={(theme) => ({ color: white, textTransform: 'capitalize' })}
        >
          <Settings sx={{ color: white }} />
          <Typography sx={{ color: white }} variant="button">
            Admin
          </Typography>
        </Button>
        <Menu
          id="headerUsername"
          anchorEl={anchorEl}
          open={menuOpen}
          onClose={this.handleCloseAccountMenu}
        >
          {allowGroupActivityReport && (
            <MenuItem id="headerGroupActivityReport" onClick={this.handleAccountMenu}>
              Activity Report
            </MenuItem>
          )}

          {allowAllActivityReport && (
            <MenuItem id="headerAllActivityReport" onClick={this.handleAccountMenu}>
              Generic Activity Report
            </MenuItem>
          )}
          {allowAllActivityReport && (
            <MenuItem id="headerAllGroupActivityReport" onClick={this.handleAccountMenu}>
              Group Reports
            </MenuItem>
          )}

          {alllowUsageReport && (
            <MenuItem
              id="headerUsageReport"
              onClick={(event, value) => this.handleAccountMenu(event, accountId)}
            >
              Usage Report
            </MenuItem>
          )}

          {allowManageUsers && (
            <MenuItem
              id="headerManageUsers"
              onClick={(event, value) => this.handleAccountMenu(event, accountId)}
            >
              Manage Users
            </MenuItem>
          )}

          {menu_billing_portal_display && (
            <MenuItem id="headerBillingPortal" onClick={this.handleAccountMenu}>
              Billing Portal
            </MenuItem>
          )}

          {menu_upgrade_subscription_display && (
            <MenuItem id="headerUpgradeSubs" onClick={this.handleAccountMenu}>
              Upgrade Subscription
            </MenuItem>
          )}

          {menu_subscription_info_display && (
            <MenuItem id="headerSubscriptionInfo" onClick={this.handleAccountMenu}>
              Subscription Info
            </MenuItem>
          )}
        </Menu>

        <SubscriptionInfoDlg
          open={subscriptionInfoDlgOpen}
          renewal_date={renewal_date}
          onCloseRequested={this.onCloseSubscriptionInfoDlgRequested}
        />

        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          open={accountMenuSnackbarOpen}
          autoHideDuration={3000}
          onClose={this.onCloseSnackbarRequested}
        >
          <SnackbarContent
            sx={(theme) => ({
              backgroundColor: isAccountMenuError ? theme.palette.error.dark : '',
              display: 'flex',
              alignItems: 'center',
            })}
            message={accountMenuSnackbarMessage}
          />
        </Snackbar>
      </span>
    );
  }

  handleAccountMenu = (event, value) => {
    if (!event || !event.target) {
      return null;
    }

    const { id } = event.target;

    switch (id) {
      case 'headerManageUsers':
        const url = '/app/users/ulist/'.concat(value);
        window.open(url, '_blank');
        break;

      case 'headerSupportCenter':
        const supportCenterUrl = AppConfig.supportCenterURLZywave;
        window.open(supportCenterUrl, '_blank');
        break;

      case 'headerGroupActivityReport':
        const groupId = this.props.userInfo.miedge_acl.ACTIVITY_REP_GROUP_ID;
        window.open('/app/actlog?group_id=' + groupId, '_blank');
        break;

      case 'headerAllActivityReport':
        window.open('/app/actlog', '_blank');
        break;

      case 'headerAllGroupActivityReport':
        window.open('/app/actlog/groups', '_blank');
        break;

      case 'headerUsageReport':
        const usageReportUrl = '/app/actlog/accounts/'.concat(value);
        window.open(usageReportUrl, '_blank');
        break;

      case 'headerBillingPortal':
        var newWindow = window.open('', '_blank');
        SiteFetch.getBillingPortalUrl().then((json) => {
          newWindow.location.href = json.billing_portal;
        });
        break;

      case 'headerUpgradeSubs':
        window.location = '/app/upgrade';
        break;

      case 'headerSubscriptionInfo':
        SiteFetch.getSubscriptionInfo().then((json) => {
          this.setState({
            subscriptionInfoDlgOpen: true,
            renewal_date: json.renewal_date,
          });
        });
        break;

      default:
      // Do nothing
    }

    this.handleCloseAccountMenu();
  };

  handleClickAccountMenu = (event) => {
    this.setState({
      anchorEl: event.currentTarget,
      menuOpen: true,
    });
  };

  handleCloseAccountMenu = () => {
    this.setState({
      anchorEl: null,
      menuOpen: false,
    });
  };

  onCloseSubscriptionInfoDlgRequested = () => {
    this.setState({
      subscriptionInfoDlgOpen: false,
    });
  };

  onCloseSnackbarRequested = () => {
    this.setState({ accountMenuSnackbarOpen: false });
  };
}

AccountMenu.propTypes = {
  userInfo: PropTypes.object.isRequired,
  onAppError: PropTypes.func.isRequired,
};

export default AccountMenu;
